











import Vue, { PropOptions } from 'vue';
export default Vue.extend({
    components: {

    },
    props: {            
        firstName: String
    },
    data() {
        return {               
        }
    }
});
